import * as TWEEN from '@tweenjs/tween.js'
import SceneControl from './core/scene/scene'
import ModelLoader from './core/model'
import createDomTexture from './utils/createDomTexture'
import { create3DLabel, createLabel } from './utils/createLabel'
import { Direction, moveLine, moveTo, moveWithLine, moveWithRound } from './utils/move'
import { appendChildren, create, createElement, setAttributes, setClassList, setEventListeners } from './utils/createElement'
import { SceneContext } from './core/global/SceneContext'
import useframe from './core/use/useframe'
import useScene from './core/use/useScene'
import useframeAfter from './core/use/useframeAfter'
import useComposerFrame from './core/use/useComposerFrame'
import useSubComposerFrame from './core/use/useSubComposerFrame'
import { InteractionManager } from './core/event/global'
import OutlinePassExtend from './extend/OutlinePassExtend'
import { TransformControls, createTransformControls } from './core/control/transformControls'
import LoaderModule from './core/load'

const utils = {
  moveTo,
  moveLine,
  moveWithRound,
  moveWithLine,
  createDomTexture,
}

const dom = {
  appendChildren,
  create,
  createElement,
  setAttributes,
  setClassList,
  setEventListeners,
}

const use = {
  useframe,
  useScene,
  useframeAfter,
  useComposerFrame,
  useSubComposerFrame,
}
export * from 'three'
export * from './threeCell'
export * from 'three-mesh-bvh'
export * from './core/use'
export * from './core/control/UniversalControls'

export {
  TWEEN,
  SceneControl,
  SceneContext,
  ModelLoader,
  TransformControls,
  createLabel,
  create3DLabel,
  Direction,
  createTransformControls,
  utils,
  dom,
  use,
  InteractionManager,
  OutlinePassExtend,
  LoaderModule,
}
